<template>
  <div>
    <Head title="STATUS erstellen" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/backend/category">KATEGORIE</Link>
      <span class="text-indigo-400 font-medium">/</span> erstellen
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.text" :error="form.errors.text" class="pb-8 pr-6 w-full lg:w-full" label="Text" />
          <text-input v-model="form.order" :error="form.errors.order" class="pb-8 pr-6 w-full lg:w-full" label="Reihenfolge" />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">STATUS erstellen</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {
    organizations: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        text: '',
        order: '',
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/backend/category')
    },
  },
}
</script>
